import { render, staticRenderFns } from "./RegisterAccountTypeSelectionPage.vue?vue&type=template&id=6af540e4&scoped=true&"
import script from "./RegisterAccountTypeSelectionPage.vue?vue&type=script&lang=js&"
export * from "./RegisterAccountTypeSelectionPage.vue?vue&type=script&lang=js&"
import style0 from "./RegisterAccountTypeSelectionPage.vue?vue&type=style&index=0&id=6af540e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af540e4",
  null
  
)

export default component.exports